

export const faturaItemTipos = ["Normal", "Juros", "Multa", "Vinculado"] as const;
export type FaturaItemTipo = typeof faturaItemTipos[number];

export interface IFaturaItem {
    faturaItemId: number
    faturaId: number
    descricao: string
    quantidade: number
    valorUnitario: number
    valorTotal: number

    contratoClienteId: number
    tipo: FaturaItemTipo
}